import "./portfolio.css";
import Card from "./Card/Card";

function Portfolio() {
  const projectsss = [
    {
      name: "CliniDo",
      desc: "CliniDo a website to solve the problem that patients face in finding and booking an appointment with the appropriate medical authority, whether it is a doctor, hospital, radiology center or analysis laboratory, in addition to the possibility of saving all the medical history,",
      techs: "HTML5 | CSS3 | Angular | firebase | I18 for transaltion",
      link: "https://clinido.vercel.app/",
      imgSrc: "clinido",
    },
    {
      name: "Service",
      desc: "Desktop service design using HTML5 used for structuring and presenting content, CSS3 used for styling and formatting of design, Javascript and ES6 and typescript used for scripting the web application, Angular used for interactive and dynamic single-page applications (SPAs) with its compelling features.",
      techs: "HTML5 | CSS3 | Angular | firebase",
      link: "https://github.com/Hady-7/service",
      imgSrc: "service",
    },
    {
      name: "Weather APP",
      desc: "a simple weather app using React js fully responsive on iPhone, Samsung, and desktop. and you can get weather for any city",
      techs: "HTML5 | CSS3 | React | Weather API",
      link: "https://weather-app-777.netlify.app/",
      imgSrc: "weather",
    },

    {
      name: "Moviesflex",
      desc: "Simple Movies app to display the latest movies and series, you can search what you want and you will get it",
      techs: "HTML5 | CSS3 | Angular | firebase for authentications | TMDB API",
      link: "https://github.com/Hady-7/Moviesflix",
      imgSrc: "moviesflex",
    },
  ];

  return (
    <div className="portfolioCard">
      {projectsss.map((project) => {
        return <Card {...project} key={project.id} />;
      })}
    </div>
  );
}

export default Portfolio;
